/* shah */
import React from 'react'

const PaperIcon = () => {
    return (
        <svg id="SmallBoxSVG-paper" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1075 1024" className="icon" style={{ display: "inline-flex" }}>
            <path xmlns="http://www.w3.org/2000/svg"
                d="M881.254 0v146.041H631.536v644.364h-154.96V146.041h-249.72V0h654.397zm63.647 1024c30.172 0 54.63-24.458 54.63-54.63s-24.458-54.636-54.63-54.636H163.207c-30.172 0-54.631 24.463-54.631 54.636s24.459 54.63 54.631 54.63h781.694z"></path>
        </svg>
    )
}

export default PaperIcon